import type { ReactNode } from 'react';

export const symbol_garage_door_open: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M305-218v-373h350v373-373H305v373Zm-85-397.18V-218h85v-343q0-12.75 8.63-21.38Q322.25-591 335-591h290q12.75 0 21.38 8.62Q655-573.75 655-561v343h85v-396L480-804 220-615.18ZM344-466h271v-85H344v85Zm136-189q12 0 21-9t9-21.5q0-12.5-9-21t-21.5-8.5q-12.5 0-21 8.62-8.5 8.63-8.5 21.38 0 12 8.63 21 8.62 9 21.37 9ZM220-158q-24.75 0-42.37-17.63Q160-193.25 160-218v-354h-55q-10.5 0-14.25-10T96-599l349-253q15.53-11 34.77-11Q499-863 515-852l349 253q9 7 5.25 17T855-572h-55v354q0 24.75-17.62 42.37Q764.75-158 740-158h-95q-12.75 0-21.37-8.63Q615-175.25 615-188v-239H344v239q0 12.75-8.62 21.37Q326.75-158 314-158h-94Z"
		/>
	</svg>
);
